import TabComponent from "./tab.container";

export default TabComponent;
